import { useMemo } from "react"
import { useTheme } from "@mui/material"
import { compact, first, get, values } from "lodash"

import {
  IContactCardData,
  IReservationCardData,
} from "extensions/iconsiam/components/domains/reservation"
import { IFeatureDetailResult } from "hooks/feature"

import {
  getReservationAppDataByLink,
  getSocialPlatformDataByLink,
} from "utils/platform"
import { IOccupantDetail } from "utils/feature"

export const useOccupantReservations = (
  data: Partial<IFeatureDetailResult>
) => {
  const theme = useTheme()
  const reservationMethods = useMemo<IReservationCardData[]>(
    () =>
      get(data, "reservations", []).reduce((list, reservation) => {
        const { logo } = data as IOccupantDetail
        const { link, ios_link, android_link } = reservation || {}
        const links = values(reservation)
        const platform = first(
          compact(
            links.map(
              (link) =>
                getReservationAppDataByLink(`${link}`) ||
                getSocialPlatformDataByLink(`${link}`)
            )
          )
        )

        const platformLogo = get(
          theme,
          `assets.platforms[${platform?.reference}].url`
        )

        list.push({
          logo: platformLogo || logo,
          qrCodes: [
            {
              type: "link",
              value: link,
              labelImage: null,
            },
            {
              type: "ios",
              value: ios_link,
              labelImage: get(theme, `assets.storeDownload.ios.url`),
            },
            {
              type: "android",
              value: android_link,
              labelImage: get(theme, `assets.storeDownload.android.url`),
            },
          ],
        })

        return list
      }, []),
    [data, theme]
  )

  const contactMethod = useMemo<IContactCardData>(() => {
    const { canReserve, phone = "" } = (data || {}) as IOccupantDetail
    if (!canReserve || !phone) return

    return {
      contactType: "phone",
      values: phone.split(","),
    }
  }, [data])

  return {
    reservationMethods,
    contactMethod,
  }
}
